<template>
  <v-toolbar color="primary">
    <v-btn :to="homeLink" icon>
      <v-icon>home</v-icon>
    </v-btn>
    <v-spacer></v-spacer>
    <img class="logo" src="/api/logo">
    <v-spacer></v-spacer>
    <v-toolbar-items class="toolbar-right">
      <v-btn-toggle v-if="activeLanguages.length > 1" v-model="currentLocale" class="lang-toggle" dense mandatory>
        <v-btn
            v-for="lang in activeLanguages"
            :key="lang.code"
            :title="lang.displayName"
            :value="lang.code"
            class="lang-btn"
            small
            text
        >
          <img :alt="lang.displayName" :src="flagSrc(lang.flag)" class="flag-icon"/>
        </v-btn>
      </v-btn-toggle>
      <v-btn :class="{hidden: ! hasImages}" text to="/basket">
        <v-badge bottom color="red" overlap>
          <template v-slot:badge color="white">{{ basketBadge }}</template>
          <v-icon>shopping_cart</v-icon>
        </v-badge>
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";

const flagModules = import.meta.glob('@/assets/flags/*.svg', {eager: true, as: 'url'});
const flags: Record<string, string> = {};
for (const [path, url] of Object.entries(flagModules)) {
  const code = path.split('/').pop()!.replace('.svg', '');
  flags[code] = url;
}

@Component({
  components: {}
})
export default class ToolBar extends BasicComponent {

  get currentLocale() {
    return this.$i18n.locale;
  }

  set currentLocale(val: string) {
    if (val && val !== this.$i18n.locale) {
      this.$i18n.locale = val;
      document.documentElement.lang = val;
      localStorage.setItem('locale', val);
    }
  }

  get activeLanguages(): { code: string, displayName: string, flag: string }[] {
    return this.$store.getters.activeLanguages ?? [];
  }

  get basketBadge() {
    return this.$store.getters.basketBadge;
  }

  get homeLink() {
    const step = this.$store.getters.step || String(this.$route.query.step);
    if (!step) {
      return "/";
    }
    return {name: "home", query: {step: step}};
  }

  flagSrc(flagCode: string): string {
    return flags[flagCode] || '';
  }

}

</script>
<style lang="scss" scoped>

.logo {
  max-height: 90%;
  height: auto !important;
  max-width: 100% !important;
  margin-top: 5px;

  @media screen and (max-width: 375px) {
    max-width: calc(100% - (2 * 88px)) !important;
  }
}

.v-toolbar {
  flex: 0 1 auto;
}

.md-primary {
  position: fixed;
  top: 0;
  z-index: 100;
}

.toolbar-right {
  display: flex;
  align-items: center;
}

.lang-toggle {
  background: rgba(255, 255, 255, 0.15) !important;
  border-radius: 4px;
  margin-right: 4px;
}

.lang-btn {
  min-width: 36px !important;
  padding: 0 6px !important;
}

.flag-icon {
  width: 24px;
  height: 16px;
  border-radius: 2px;
  object-fit: cover;
}

</style>
<style lang="scss">

.hidden {
  visibility: hidden;
}

.md-menu-content {
}

.basket_icon, .home_icon {
  color: white !important;
}

.basketBadge {

  .md-badge {
    margin-right: 15px;
    margin-bottom: 5px;
  }
}
</style>
